import React from "react";
import { ExtraProps } from "react-markdown";
import { oneDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import { SyntaxHighlighter } from "./SyntaxHighlighter";

export const codeMapper = (
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLElement>,
    HTMLElement
  > &
    ExtraProps
) => {
  const { children, className, node: _node, ...rest } = props;
  const match = /language-(\w+)/.exec(className || "");
  return match ? (
    <SyntaxHighlighter PreTag="div" language={match[1]} style={oneDark}>
      {String(children).replace(/\n$/, "")}
    </SyntaxHighlighter>
  ) : (
    <code {...rest} className={className}>
      {children}
    </code>
  );
};
